export function resetCursorPosition(): void {
    const focusedInput = <HTMLInputElement>document.activeElement;
    const selectionStart = focusedInput.selectionStart;
    setTimeout(() => {
        focusedInput.selectionStart = selectionStart;
        focusedInput.selectionEnd = selectionStart;
    });
}
